import React from 'react';

import { LEVEL_TRAVEL_OPERATOR_ID } from 'src/constants/flights';
import { useTranslation } from '@lt/localization';
import { FLIGHT_TYPES_NAME } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import FlightsRoute from '../Flights/FlightsRoute';
import FlightsLuggageSummary from '../Flights/Luggage/FlightsLuggageSummary';
import {
  baseCls,
  detailsCls,
} from '../Flights/FlightsItemContainer/components/FlightsItem';
import UpgradeFlightSummary from '../../containers/Services/components/UpgradeFlightClass/UpgradeFlightSummary';
import FlightsPropTypes from '../../proptypes/flights';
import FlightType from '../Flights/FlightType';
import { getFlightTypeData } from '../../utils/flightUtils';

const UpgradeFlightItem = ({ businessFlightData }) => {
  const { t } = useTranslation();
  const { to, back } = businessFlightData;

  const summaryLuggage = [to.luggage, back.luggage];

  const isLevelTravelTourOperator =
    back.operator_id === LEVEL_TRAVEL_OPERATOR_ID;
  const toFlightTypeData = getFlightTypeData(to);
  const backFlightTypeData = getFlightTypeData(back);
  const toFlightTypeIsRegular =
    toFlightTypeData.flightType === FLIGHT_TYPES_NAME.REGULAR;
  const backFlightTypeIsRegular =
    backFlightTypeData.flightType === FLIGHT_TYPES_NAME.REGULAR;
  const isShowToTooltip = toFlightTypeIsRegular && !isLevelTravelTourOperator;
  const isShowBackTooltip =
    backFlightTypeIsRegular && !isLevelTravelTourOperator;

  return (
    <div className={`${baseCls} checkout-flights__item ${baseCls}--additional`}>
      <div className={`${baseCls}__cutout`} />
      <div className={`${detailsCls} ${baseCls}__details`}>
        <div className={`${detailsCls}__item`}>
          <div
            className={`${detailsCls}__item-label ${detailsCls}__item-label_to`}
          >
            {t('checkout.flight.item.to')}
          </div>
          <FlightsRoute data={to} type="to" showLogo />
          <FlightType
            type={toFlightTypeData}
            showDescription={isShowToTooltip}
            showTooltip={isShowToTooltip}
          />
        </div>
        <div className={`${baseCls}__separator`} />
        <div className={`${detailsCls}__item`}>
          <div
            className={`${detailsCls}__item-label ${detailsCls}__item-label_back`}
          >
            {t('checkout.flight.item.back')}
          </div>
          <FlightsRoute type="back" data={back} showLogo />
          <FlightType
            type={backFlightTypeData}
            showDescription={isShowBackTooltip}
            showTooltip={isShowBackTooltip}
          />
        </div>
      </div>
      <div className={`${baseCls}__details-right`}>
        <FlightsLuggageSummary summaryLuggage={summaryLuggage} />
        <UpgradeFlightSummary businessFlightData={businessFlightData} />
      </div>
    </div>
  );
};

UpgradeFlightItem.propTypes = {
  businessFlightData: FlightsPropTypes.item.isRequired,
};

export default UpgradeFlightItem;
